import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { useGroupFilters } from '@app/group/hooks/use-group-filters';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupProducts } from '@shared/api/hooks/group/products';
import { GroupProductsListSortItem } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import GroupPage from '../components/group-page';
import GroupProductsTable from '../components/tables/group-products-table';

export default function GroupProductsPage() {
  const { page, perPage, sort } = useDataTableQueryState();
  const [name] = useQueryState('name', parseAsString);
  const [{ orgs }] = useGroupFilters();

  const data = useGetGroupProducts({
    page,
    page_size: perPage,
    sort: formatMultipleSortingForEndpoint(
      sort ?? []
    ) as GroupProductsListSortItem[],
    organizations: orgs.length ? orgs : undefined,
    search: name || undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load group products');

  return (
    <GroupPage pageKey="products">
      <GroupProductsTable {...data} pageCount={pageCount} />
    </GroupPage>
  );
}
